// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"styles_dataTable__1T97T","taskItem":"styles_taskItem__2rPHI","footerRow":"styles_footerRow__2hD-w"};